import React from 'react';
import Helmet from 'react-helmet';
import MultipleQuotes from '../shared/MultipleQuotes';
import HeaderLine from '../shared/HeaderLine';
import TrialRequestForm from './form/TrialRequestForm';
import './Request.scss';
import PrimarySection from '../../shared/components/primary-section/PrimarySection';
import { PrimarySectionIndent } from '../../shared/components/primary-section/PrimarySectionIndent';
import { ColorScheme } from '../../shared/enums/ColorScheme';
import PrimarySectionRow from '../../shared/components/primary-section/PrimarySectionRow';
import { AlignTypesHorizontal } from '../../shared/enums/AlignTypesHorizontal';
import CarouselWithAllClients from '../shared/CarouselWithAllClients';
import { OptimizedPictureType } from '../shared/optimized-picture/enums/OptimizedPictureType';
import FeatureNoTrialButton from '../shared/FeatureNoTrialButton';
import RequestSteps from './RequestSteps';
import WhatClientsSay from './WhatClientsSay';
import CarouselWithAllClients2 from '../shared/CarouselWithAllClients2';

const Request: React.FC = () => {
  return (
    <div className="Request">
      <Helmet>
        <title>Request &mdash; Renaissance Capital</title>
      </Helmet>
      <FeatureNoTrialButton
        header={
          <span>
            The Institutional Edge
            <span className="d-lg-block d-xl-block" /> For Premier IPO Investors
          </span>
        }
        optimizedPictureType={OptimizedPictureType.TrialPageHeader}
      >
        Request Access to IPO Intelligence™
      </FeatureNoTrialButton>
      <RequestSteps />
      <PrimarySection>
        <PrimarySectionRow className="Request__mainRow">
          <div className="Request__mainCol Request__mainCol--left">
            <h2 className="Request__mainHeadline">
              Request full access to the independent
              <br />
              <em>IPO insights top institutions rely on.</em>
            </h2>

            <div className="Request__rate">Actual rate (USD) $39,300/yr (includes up to 6 users)</div>

            <div className="Request__subcopy">
              <strong>A whole team of IPO experts for a fraction of the cost of one analyst</strong>
            </div>

            <div className="Request__formWrap">
              <TrialRequestForm />
            </div>
          </div>

          <div className="Request__mainCol Request__mainCol--right">
            <h3 className="Request__benefitsHeadline">
              Why <em>smart</em> institutions leverage
              <br />
              IPO Intelligence<sup>™</sup>
            </h3>

            <div className="Request__benefitsList">
              <div className="Request__benefitCard">
                <div className="Request__benefitTitle">Elite institutional validation</div>
                <div className="Request__benefitBody">
                  Join top hedge funds and $200B+ asset managers who trust Renaissance Capital’s research
                </div>
              </div>

              <div className="Request__benefitCard">
                <div className="Request__benefitTitle">$400K+ Annual savings</div>
                <div className="Request__benefitBody">
                  Like adding a $400K senior analyst with 35+ years of proven IPO experience
                </div>
              </div>

              <div className="Request__benefitCard">
                <div className="Request__benefitTitle">Independence you can’t buy in house</div>
                <div className="Request__benefitBody">
                  Gain unbiased IPO ratings without influence, internal politics, or conflicts
                </div>
              </div>

              <div className="Request__benefitCard">
                <div className="Request__benefitTitle">Real-time Excel models and comp tables</div>
                <div className="Request__benefitBody">
                  Access dynamic DCF models and comp tables immediately. No building or debugging required
                </div>
              </div>

              <div className="Request__benefitCard">
                <div className="Request__benefitTitle">35+ Year track record</div>
                <div className="Request__benefitBody">
                  Leverage proven IPO methodology based on decades of proprietary data with documented performance
                  versus unproven new hires
                </div>
              </div>
            </div>
          </div>
        </PrimarySectionRow>
      </PrimarySection>
      <WhatClientsSay />
      <PrimarySection indent={PrimarySectionIndent.Internal} colorScheme={ColorScheme.Primary}>
        <HeaderLine>Trusted by the smartest investors and deal makers</HeaderLine>
      </PrimarySection>

      <PrimarySection>
        <PrimarySectionRow className="Request__value">
          <div>
            With a <strong>92% renewal rate</strong>, many of our clients have trusted us as their partner in the IPO
            market for more than <strong>two decades</strong>.
          </div>
        </PrimarySectionRow>
      </PrimarySection>

      <PrimarySection indent={PrimarySectionIndent.Internal}>
        <CarouselWithAllClients />
        <br />
        <CarouselWithAllClients2 />
      </PrimarySection>
    </div>
  );
};

export default Request;
